import React, { useEffect, useState } from 'react'
import Select, { CSSObjectWithLabel } from 'react-select'
import { getIn } from 'formik'

type DropdownProps = {
  fieldName: string
  optionList: any
  handleSelectedItem: any
  fieldDisabled?: boolean
  formik?: any
  selectedVal?: any
  data?: any
  hasError?: any
  className?: string
  isSolarProduct?: boolean
}

const Dropdown = ({
  fieldName,
  optionList,
  handleSelectedItem,
  fieldDisabled,
  formik,
  selectedVal,
  data,
  hasError = false,
  className = '',
}: DropdownProps) => {
  const [optionItems, setOptionItems] = useState<any>([])
  useEffect(() => {
    const tempList: any = [
      { value: '', label: 'Select option' },
    ]
    optionList?.forEach((element: any) => {
      tempList.push({
        value: fieldName === 'script' ? element.scriptId : element.id,
        label: fieldName === 'script' ? element.scriptName : element.value,
        isDisabled: Boolean(element.isDisabled),
      })
    })
    setOptionItems(tempList)
  }, [optionList])

  const handleDropdownValue = () => {
    if (!optionList?.length) {
      return null
    }

    const fieldValue = formik ? getIn(formik.values, fieldName) : selectedVal
    const safeLower = (val: any) =>
      typeof val === "string" ? val.toLowerCase() : String(val || "").toLowerCase()

    let matched

    if (fieldName === "script") {
      matched = optionList.find(
        (el: any) => safeLower(el.scriptName) === safeLower(fieldValue)
      )
      return matched
        ? { value: matched.scriptId, label: matched.scriptName }
        : null
    } else {
      matched = optionList.find(
        (el: any) => safeLower(el.value) === safeLower(fieldValue)
      )
      return matched
        ? { value: matched.id, label: matched.value }
        : null
    }
  }


  return (
    <>
      <Select
        id={fieldName}
        className={`basic-single ${className}`}
        classNamePrefix="dropdown"
        isSearchable
        name={fieldName}
        value={handleDropdownValue()}
        options={optionItems}
        onChange={(e: any) => handleSelectedItem(e, fieldName)}
        isDisabled={fieldDisabled}
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
          } as CSSObjectWithLabel),
        }}
      />

      {formik ? (
        getIn(formik.touched, fieldName) &&
        getIn(formik.errors, fieldName) && (
          <div className="fv-plugins-message-container">
            <div className="fv-help-block">{getIn(formik.errors, fieldName)}</div>
          </div>
        )
      ) : (
        !data && hasError && (
          <div className="text-danger">{fieldName} is required</div>
        )
      )}
    </>
  )
}

export default Dropdown
